(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["master-product"] && !Shopify.designMode) return;
  try {
    
if (!window.masterVariantBound) { window.masterVariantBound = true; document.addEventListener('change', (event) => { if (event.target.matches('[data-variant-picker]')) window.location.assign(event.target.value); }); }

  } catch(e) { console.error(e); }
})();
})();
